module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcleg3-e8983aa6597de13bd69eeafe887c2c5c.jpg";